import React, {useEffect, useState} from "react";
import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import Button from "../Button";
import Switch from "react-switch";

const defaultName = {
    "full": "حذف کل افزونه",
    "IAuth": "احراز هویت تصویری",
    "PoliceClearance": "سو پیشینه",
    "BusinessLicenseInquiry": "پروانه کسب و کار",
    "ExpertInquiry": "پروانه کارشناس قوه قضاییه",
    "LawyerInquiry": "پروانه وکالت"
}
const DeleteAuthenticationModal = (props) => {

    const {widget, handleDeleteWidget} = props;
    const [selectedType, setSelectedType] = useState("full");

    const [serviceList, setServiceList] = useState([]);

    useEffect(() => {
        if (widget) {
            let list = []
            widget.service_types.forEach((serviceType) => {

                if (serviceType === "IAuth") {
                    if (widget.service_types.includes("PoliceClearance")) {
                        if (widget?.widgets_body?.police_clearance_status) {
                            list.push({
                                serviceType,
                                name: defaultName[serviceType] + " و " + defaultName["PoliceClearance"]
                            })
                        } else {

                            list.push({serviceType, name: defaultName[serviceType]})
                        }

                    } else {
                        list.push({serviceType, name: defaultName[serviceType]})
                        setServiceList([...serviceList, {serviceType, name: defaultName[serviceType]}])
                    }
                } else if (serviceType !== "PoliceClearance") {
                    list.push({serviceType, name: defaultName[serviceType]})
                } else if (serviceType === "PoliceClearance"&&!widget?.available_services?.includes("IAuth")) {
                    list.push({serviceType, name: defaultName[serviceType]})
                }
            })
            setServiceList([...list])
        }
    }, [])
    const handleDelete = () => {

        if (selectedType === "full") {
            handleDeleteWidget()
        } else if (selectedType.includes("IAuth")) {
            handleDeleteWidget("IAuth")
        } else {
            handleDeleteWidget(selectedType)
        }
    }
    const handleSwitch = (isChecked, serviceType) => {

        if (isChecked) {
            if (serviceType === "IAuth" || serviceType === "PoliceClearance") {
                setSelectedType("iAuth+PoliceClearance")
            } else {
                setSelectedType(serviceType)
            }
        }
    }
    const handleClose = () => Reoverlay.hideModal()
    return <ModalWrapper onClose={() => {
    }} animation="slideDown"
                         contentContainerClassName="w-11/12 flex flex-col justify-center items-center flex-col md:8/12 lg:w-4/12 p-5 rounded-xl">
        <h1 className="text-xl font-bold mb-1 ">حذف افزونه</h1>
        <div className="border-t  w-full mt-3 "/>
        <div className="w-full border-gray-100 border">
            <div className="flex justify-between p-2 w-full bg-gray-100 mb-2   ">
                <label className="text-sm">{defaultName["full"]}</label>
                <Switch onColor="#36b570" onChange={(isChecked) => handleSwitch(isChecked, "full")} dir="rtl" size={50}
                        checkedIcon={false} uncheckedIcon={false} height={20} width={40}
                        checked={selectedType === "full"}/>
            </div>
            {serviceList &&widget.service_types && widget.service_types.length>1  && serviceList.length > 0 && serviceList.map((service, index) => {
                let show = true;
                switch (service.serviceType) {
                    case "IAuth": {
                        if (widget.widgets_body && !widget.widgets_body.iauth_img_name) {
                            show = false;
                        }
                        break
                    }
                    case "BusinessLicenseInquiry": {
                        if (widget.widgets_body && !widget.widgets_body.bi_type) {

                            show = false;
                        }
                        break
                    }
                    case "PoliceClearance": {
                        if (widget.widgets_body && !widget.widgets_body.police_clearance_status) {
                            show = false;
                        }
                        break
                    }
                    default: {

                        break
                    }
                }
                return show && <div key={service.serviceType}
                                    className={`${index % 2 === 0 ? "bg-white" : "bg-gray-100"} flex justify-between  p-2 w-full my-2  `}>
                    <label className="text-sm">{service.name}</label>
                    {widget.deleted_widgets.includes(service.serviceType) ?
                        <span className="text-red-400 rounded-lg text-xs p-1 bg-red-100 ">حذف شده</span> :
                        <Switch onColor="#36b570" onChange={(isChecked) => handleSwitch(isChecked, service.serviceType)}
                                dir="rtl"
                                size={50} checkedIcon={false} uncheckedIcon={false} height={20} width={40}
                                checked={selectedType.includes(service.serviceType)}/>}

                </div>
            })}
        </div>
        {widget.service_types.includes("PoliceClearance") && <p className="w-full my-2  bg-red-100 text-sm p-3 rounded-lg  text-red-500">تایید احراز هویت و عدم سوءپیشینه بصورت یکپارچه (با هم) ارائه می گردد. در صورت حذف هر کدام ، دیگری نیز حذف خواهد شد.</p>}

        <div className="grid-cols-2 grid gap-2  w-full">
            <Button rounded="rounded-lg" onClick={handleDelete} type="button" className="mt-2 text-sm  w-full"
                    theme="red">حذف افزونه</Button>
            <Button rounded="rounded-lg" onClick={handleClose} type="button" className="mt-2 text-sm  w-full"
                    theme="light">بستن</Button>
        </div>
    </ModalWrapper>
}
export default DeleteAuthenticationModal;